import { initMarketingPage } from '@bark/bark-core/src/components/start/marketing-page';
import { routerUrl } from './router';
// run
export async function main() {
	initMarketingPage();
	routerUrl();
}

main().then(() => {
	console.log('marketing page app start');
});
